import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    document.body.style.overflow = 'hidden' // Prevent scrolling
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.body.style.overflow = '' // Re-enable scrolling
    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown = (event) => {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  close() {
    // Clear the turbo frame
    const modalFrame = document.getElementById('modal')
    if (modalFrame) {
      modalFrame.innerHTML = ''
    }
  }
}
